<template>
<v-snackbar v-model="snackbar" :color="color" :multi-line="mode === 'multi-line'" :timeout="timeout" :vertical="mode === 'vertical'">
  <slot>Message Here</slot>
</v-snackbar>
</template>

<script>
export default {
  name: "MessageBar",
  props: {
    visible: Boolean,
    type: String
  },
  data: function() {
    return {
      snackbar: true,
      mode: '',
      timeout: 0,
      text: '',
      color: 'red darken-4'
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Shared/MessageBar.vue